import { IOneMessageJson } from "../../../../../../nodeserver/structs/database.js";
import { 
    canChangeOrSeeMessage, 
    currentMessageQuery, 
    hasSpecialActions, 
    resize, 
    rotateBack, 
    rotateMinus45deg, 
} from "../../../messages/helpers.js";
import JSX from "./../../../helpers/react.js";
import RefObject = JSX.RefObject;
import { hideUserMessageActionsDetails } from "../user-actions.js";
import { handleFetchError } from "../../../helpers/functions.js";
import { ServerApi } from "../../../api.js";
import { addActionElementToBottomSender, deleteActionElementFromBottomSender, messageTextArea, setMessagteTextAreaToDefault } from "../../../messages/bottom.js";

export function EditActionElement(props:{
    msg: IOneMessageJson,
    message: RefObject<HTMLDivElement>,
    withText: boolean
}){
    
    const text = props.msg.text;
    const userFromId = props.msg.from_id;
    
    const lastEditedById = props.msg.edited_by_id;
    const isDeleted = props.msg.deleted;

    const editElement = !isDeleted && hasSpecialActions(userFromId) && canChangeOrSeeMessage(lastEditedById) ? (
        <div className="action-element"
            onClick={e => editMessageClickEventHandler(e, props.message.value!, text)}
        >
            <div className="edit-message-action message-action-padding">
                <img src="/img/edit-message.svg" className="action-element-img"/>
            </div>
            {!!props.withText && <div className="message-action-padding main-yellow-font">Отредактировать</div>}
            
        </div>
    ) : <></>;

    return editElement;
}


function editMessageClickEventHandler(
    event: MouseEvent & {
        target: HTMLElement
    },
    message: HTMLDivElement,
    text: string
) {

    hideUserMessageActionsDetails(message);
    if (!isEditingMessage())
        activateMessageEdition(message, text);
    else
        disactivateMessageEdition(message);


}
export async function updateMessageClickEventHandler() {
    // setTimerActionAndThrowErrorIfTimeNotPass();
    const $el = $('.update-message-area-action');
    const messageId = $el.data("message-id");
    const textArea = messageTextArea();

    // const oldText = messageOldTextElement[0].innerHTML;
    const newMessage: string = (textArea.val() as string).trim();

    if (newMessage && $el.data('text') != newMessage) {
        try {
            await ServerApi.messages.editMessage(messageId, newMessage);
        } catch (e) {
            handleFetchError(e);
        }
        disactivateMessageEdition($<HTMLDivElement>(currentMessageQuery(messageId)!)[0]!);
    }
}



export function activateMessageEdition(message: HTMLDivElement, text: string) {
    const messageTextAreaEl = messageTextArea();

    messageTextAreaEl.val(text);
    resize(messageTextAreaEl[0]);

    const editBlock: HTMLElement = <EditMessageBlock messageId={+message.dataset.id!} text={text}
                                                     message={{value: message}}/>;
    addActionElementToBottomSender(editBlock);
    rotateEditIconBack(message);
}


export function rotateEditIconBack(message: HTMLDivElement) {
    let messageEditSvgElement = $(message).find(".edit-message-action .action-element-img");
    messageEditSvgElement.addClass(rotateMinus45deg).removeClass(rotateBack);
}


export function EditMessageBlock(props: {
    messageId: number,
    text: string,
    message: RefObject<HTMLDivElement>
}): HTMLElement {
    return (
        <div className="update-message-area-action action-bottom-sender-block"
             data-message-id={props.messageId}
             data-text={props.text}
             onClick={() => disactivateMessageEdition(props.message.value!)}
        >
            <span className="yellow-color">Редактирование&nbsp;</span>
            <span>сообщения</span>
        </div>
    )
}




export function isEditingMessage() {
    return $(".bottom-sender .update-message-area-action").length > 0;
}

export function rotateEditAction(message: HTMLDivElement) {
    let messageEditSvgElement = $(message).find(".edit-message-action .action-element-img");
    messageEditSvgElement.removeClass(rotateMinus45deg).addClass(rotateBack);
}

export function disactivateMessageEdition(message: HTMLDivElement) {

    const messageTextAreaEl = messageTextArea();

    messageTextAreaEl.val('');

    deleteActionElementFromBottomSender("update-message-area-action");
    rotateEditAction(message);
    setMessagteTextAreaToDefault();
}

